const calculateBorderRadius = (radius, elementHeight) => ((elementHeight / 2) * radius) / 100;

export default calculateBorderRadius;
